import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ChapterCard from '@/pages/capitulos-dormir-tranquila/components/ChapterCard';
import { libraryCollection } from '@/mocks/neurobaby';

// Checkouts de Hotmart por capitulo (1 al 10) segun el idioma de la pagina
const chapterCheckouts: Record<'es' | 'en', Record<number, string>> = {
  es: {
    1: 'https://pay.hotmart.com/N107295989G',
    2: 'https://pay.hotmart.com/J107373448S',
    3: 'https://pay.hotmart.com/O107373608M',
    4: 'https://pay.hotmart.com/Q107373898M',
    5: 'https://pay.hotmart.com/Y107373940H',
    6: 'https://pay.hotmart.com/M107374022O',
    7: 'https://pay.hotmart.com/O107374130X',
    8: 'https://pay.hotmart.com/D107374170N',
    9: 'https://pay.hotmart.com/K107374187W',
    10: 'https://pay.hotmart.com/E107374206K',
  },
  en: {
    1: 'https://pay.hotmart.com/L107374257D',
    2: 'https://pay.hotmart.com/J107374331E',
    3: 'https://pay.hotmart.com/A107374378I',
    4: 'https://pay.hotmart.com/V107374728C',
    5: 'https://pay.hotmart.com/H107374796X',
    6: 'https://pay.hotmart.com/G107374822A',
    7: 'https://pay.hotmart.com/H107374842H',
    8: 'https://pay.hotmart.com/V107374989F',
    9: 'https://pay.hotmart.com/C107375109K',
    10: 'https://pay.hotmart.com/U107375154S',
  },
};

export default function CapitulosDormirTranquila() {
  const { t, i18n } = useTranslation();

  const langKey: 'es' | 'en' = i18n.language === 'en' ? 'en' : 'es';

  return (
    <div className="min-h-screen bg-cream">
      <Navbar />

      {/* Hero */}
      <section className="pt-28 md:pt-36 pb-10 md:pb-16 px-6 md:px-10">
        <div className="w-full max-w-7xl mx-auto text-center">
          <span className="inline-block font-sans text-xs font-semibold text-terracotta uppercase tracking-[0.2em] mb-4">
            {t('capitulos.hero.badge')}
          </span>
          <h1 className="font-serif text-4xl md:text-6xl font-bold text-[#8B6F5C] leading-tight">
            {t('capitulos.hero.title1')}
            <br />
            {t('capitulos.hero.title2')}
          </h1>
          <p className="font-sans text-base md:text-lg text-[#3D2B1F] max-w-2xl mx-auto mt-6 leading-relaxed">
            {t('capitulos.hero.desc')}
          </p>
        </div>
      </section>

      {/* Capítulos */}
      <section className="pb-16 md:pb-24 px-6 md:px-10">
        <div className="w-full max-w-5xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-serif text-2xl md:text-3xl font-bold text-[#8B6F5C] leading-tight">
              {t('capitulos.section.title')}
            </h2>
            <p className="font-sans text-sm text-[#3D2B1F] mt-3 max-w-2xl mx-auto">
              {t('capitulos.section.desc')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            {libraryCollection.map((chapter) => (
              <ChapterCard
                key={chapter.id}
                chapter={chapter}
                checkoutUrl={chapterCheckouts[langKey][chapter.id]}
              />
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}